import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCOaKQVcQSl4o4iuN5HVnskUy0l-7VLdlw",
  authDomain: "bccexx-a4f05.firebaseapp.com",
  projectId: "bccexx-a4f05",
  storageBucket: "bccexx-a4f05.firebasestorage.app",
  messagingSenderId: "104411296584",
  appId: "1:104411296584:web:67d9363a9fe3aac8f7f97d",
  measurementId: "G-GM1NWEG12M"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

const vapidKey = "BBbuYumiqJ5atOMJMBCl0GXr6vtFZWxEcFd0CS3soDNmq1_4IpvE0Hdwa9tVQbHqAV5LVO0ByAlL5Y7z27ILzNs";

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted.');

      const token = await getToken(messaging, {
        vapidKey: vapidKey
      });

      if (token) {
        console.log('Registration token:', token);
        return token;
      } else {
        console.log('No registration token available.');
        return null;
      }
    } else {
      console.log('Unable to get permission to notify.');
      return null;
    }
  } catch (error) {
    console.log('An error occurred while retrieving token. ', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      resolve(payload);
    });
  });